module.exports = __webpack_public_path__ + "img/elevator_big_closing.5934565e.gif";